// nome del profilo di sviluppo
export const DEV_PROFILE_NAME = 'STAGING'
// profilo attivo
export const BUILD_PROFILE = process.env.REACT_APP_BUILD_PROFILE ?? DEV_PROFILE_NAME

// base url del servizio backend
export const BASE_MS_URL = process.env.REACT_APP_BASE_MS_URL ?? '#'

export const LOGIN_URL = BASE_MS_URL + 'api/v1/users/login'

export const REGISTER_URL = BASE_MS_URL + 'api/v1/users/register'

export const MY_DATA_URL = BASE_MS_URL + 'api/v1/users/my-data?with_qr_form_lists=1'

// dominio dei cookie
export const APP_DOMANIN = process.env.REACT_APP_DOMAIN ?? '6sicuro.it'

export const BLOG_URL = process.env.REACT_APP_BLOG_URL ?? '#'